import { render } from "./patients-grid-upcoming.vue?vue&type=template&id=3a4959bf"
const script = {}

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__